<div id="top-of-page"></div>
<app-back-header
  [headerText]="'Torna alla dashboard'"
  (backAction)="backToDashboard()"
  class="sticky-top">
</app-back-header>

<!-- Header: titolo + riga di stato della schermata, come le altre sezioni
     (documenti, porta un amico, tabelle). -->
<div class="mt-3 ms-1 mb-3 w-100">
  <h3 class="m-0">Dichiarazione dei redditi</h3>
  <p class="m-0 text-muted" *ngIf="!isLoading && incomeStatements.length > 0">
    La tua dichiarazione è pronta: trovi i dettagli qui sotto.
  </p>
  <p class="m-0 text-muted" *ngIf="!isLoading && incomeStatements.length === 0">
    Ti avvisiamo noi appena la tua dichiarazione è disponibile.
  </p>
</div>

<!-- Loading State -->
<div *ngIf="isLoading" class="loading-container">
  <mat-progress-spinner diameter="50" mode="indeterminate"></mat-progress-spinner>
  <p class="mt-3">Caricamento in corso...</p>
</div>

<!-- Empty State: l'illustrazione del brand al posto dell'icona opaca, con la
     stessa impaginazione centrata degli altri stati vuoti. -->
<div *ngIf="!isLoading && incomeStatements.length === 0" class="empty-container">
  <img class="empty-image" src="izy_image_2.png" alt="Nessuna dichiarazione disponibile">
  <h3 class="mt-4">È ancora presto! Passa più tardi.</h3>
  <p>Quando i nostri Commercialisti avranno elaborato la tua dichiarazione, la troverai qui.</p>
</div>

<!-- Statement Cards -->
<div *ngIf="!isLoading && incomeStatements.length > 0" class="statements-list">
  <!-- Card dichiarazione: superficie piatta bianca con bordo nero 2px e angolo
       basso-sinistra vivo (utility globali .custom-card-border /
       .izy-sharp-bl), con il comando nel footer su fondo panna separato dal
       tratto nero 2px - come le card documento e bozza. -->
  <mat-card
    *ngFor="let statement of incomeStatements"
    class="statement-card izy-sharp-bl custom-card-border"
  >
    <mat-card-content class="statement-content">
      <div class="statement-heading">
        <span class="izy-corner-icon">
          <mat-icon>description</mat-icon>
        </span>
        <div class="statement-heading-text">
          <h6 class="statement-name">{{ statement.name }}</h6>
          <p class="statement-meta mb-0">
            <mat-icon class="statement-meta-icon me-1">calendar_today</mat-icon>
            {{ statement.date | date:'dd MMMM yyyy' }}
          </p>
        </div>
      </div>

      <p *ngIf="statement.message" class="statement-message">
        {{ statement.message }}
      </p>

      <p class="statement-meta mb-0">
        <mat-icon class="statement-meta-icon me-1">person_outline</mat-icon>
        <span class="statement-meta-label me-1">Mittente:</span>
        {{ statement.sender }}
      </p>
    </mat-card-content>

    <div
      *ngIf="statement.attached_file"
      class="d-flex justify-content-end align-items-center statement-card-footer"
    >
      <button
        mat-stroked-button
        type="button"
        (click)="openAttachment(statement.attached_file)"
        matTooltip="Apri la dichiarazione in una nuova scheda."
        [matTooltipShowDelay]="showDelay.value"
        [matTooltipHideDelay]="hideDelay.value"
        class="me-2 statement-attachment-btn custom-button-border"
      >
        <mat-icon>open_in_new</mat-icon>
        Apri dichiarazione
      </button>
    </div>
  </mat-card>
</div>

<!-- Card guida: stessa card azione della dashboard (superficie info bordata
     nera con angolo vivo e barra "apri" con la freccia nel tondo bianco).
     Prima era duplicata, una copia per ciascuno dei due stati della pagina. -->
<mat-card
  *ngIf="!isLoading"
  class="mt-3 izy-sharp-bl custom-card-blue custom-card-border guide-card"
  (click)="openGuide5Dialog()"
  matTooltip="Apri la guida su Regime Forfettario e scadenze fiscali."
  [matTooltipShowDelay]="showDelay.value"
  [matTooltipHideDelay]="hideDelay.value"
>
  <mat-card-content class="p-0 mx-2 my-3">
    <div class="card-body p-0">
      <div class="mb-2 d-flex m-0 justify-content-between align-items-center">
        <p class="mb-0">Qualcosa non ti è chiaro?</p>
        <mat-icon class="me-1" fontSet="material-icons-outlined">help</mat-icon>
      </div>
      <p class="mb-2">
        Consulta la nostra guida su Regime Forfettario e Scadenze fiscali.
      </p>
      <mat-card class="izy-goto-card clickable-blue custom-card-blue">
        <mat-card-content class="p-0 m-1">
          <div class="d-flex m-0 justify-content-between align-items-center">
            <span class="izy-goto-label">Apri la guida</span>
            <span class="izy-goto-arrow">
              <mat-icon fontSet="material-icons-outlined">chevron_right</mat-icon>
            </span>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </mat-card-content>
</mat-card>

<div class="pt-3 mb-3"></div>
